import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  likeContainer: {
    flexDirection: 'row',
    zIndex: 100,
    // Ensure the button has proper touch area
    minWidth: 44,
    minHeight: 44,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default styles;
